import { useGLTF } from "@react-three/drei"

//const {scene, objects, materials} = useGLTF("models/material.glb")
export function getMaterial () {
    
    //const materials = "asbdsadasd"    
    const {scene, objects, materials} = useGLTF("models/material.glb")

    /* Traverse all custom materials
       Then update all the mat names accordingly
       Material[k].name should give the standard response
       This ensures the coloring process continues
    */

    const keys = Object.keys(materials)
    for (var i = 0; i < keys.length ; i++){
        var currKey = keys[i];
        var name = materials[currKey].name
        if ( name.startsWith("c")){
            materials[currKey].name = "car_paint"
        } else if (name.startsWith("fg")){
            materials[currKey].name = "front_glass"
        } else if (name.startsWith("fsg")){
            materials[currKey].name = "front_side_glass"
        } else if (name.startsWith("bsg")){
            materials[currKey].name = "back_side_glass"
        } else if (name.startsWith("bg")){
            materials[currKey].name = "back_glass"
        }
    }
    /*
    materials['c01_default'].name = "car_paint"
    materials['fg01_default'].name = "front_glass"
    materials['fsg01_default'].name = "front_side_glass"
    materials['bsg01_default'].name = "back_side_glass"
    materials['bg01_default'].name = "back_glass"
    */
    //console.log(materials)

    return materials;
}
